/*
 * @Author: zhaohaozhuang
 * @Date: 2022-04-20 14:01:47
 * @LastEditors: liuxiaoyan
 * @LastEditTime: 2023-05-19 18:15:40
 * @Description: 描述一下咯
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
 */
export default {
  routes: [
    {
      path: '/artgallery',
      name: 'artgallery',
      component: () => import('@/module/artGallery/index.vue'),
      meta: {
        title: '书画馆',
        keepAlive: true,
        logined: false,
      },
    },
    {
      path: '/artgalleryclass',
      name: 'artgalleryclass',
      component: () => import('@/module/artGallery/classfallery.vue'),
      meta: {
        title: '书画馆',
        keepAlive: true,
        logined: false,
      },
    },
    {
      path: '/artgallery/detail',
      name: 'artgallery_detail',
      component: () => import('@/module/artGallery/details.vue'),
      meta: {
        title: '',
        keepAlive: false,
        logined: false,
      },
    },
    {
      path: '/artgallery/classartmuseum',
      name: 'artgallery_classartmuseum',
      component: () => import('@/module/artGallery/ClassArtMuseum.vue'),
      meta: {
        title: '书画馆',
        keepAlive: false,
        logined: false,
      },
    },
    {
      path: '/artgallery/shareshow',
      name: 'artgallery_shareshow',
      component: () => import('@/module/artGallery/Shareshow.vue'),
      meta: {
        title: '海报分享',
        keepAlive: false,
        logined: false,
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/ArtGallery.js